import { AutoLockFormsLevelType, FormNames } from '../autoLockForms.constants';

const formFields = [
  {
    name: 'feeProviderId',
    label: 'Fee Providers',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'referenceNumber',
    label: 'Reference #',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'closingAgentContact',
    label: 'Contact',
    levelType: AutoLockFormsLevelType.FIELD,
  },
];

export const closingAgentForm = {
  name: FormNames.FUNDING_INFORMATION,
  label: 'Closing Agent',
  levelType: AutoLockFormsLevelType.FORM,
  children: formFields,
};
